import { render } from "./DynamicTabPanel.vue?vue&type=template&id=5d051b26&ts=true"
import script from "./DynamicTabPanel.vue?vue&type=script&lang=ts"
export * from "./DynamicTabPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicTabPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d051b26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d051b26', __exports__)) {
    api.reload('5d051b26', __exports__)
  }
  
  module.hot.accept("./DynamicTabPanel.vue?vue&type=template&id=5d051b26&ts=true", () => {
    api.rerender('5d051b26', render)
  })

}


export default __exports__